import { render, staticRenderFns } from "./profile2.vue?vue&type=template&id=c67a3844&scoped=true&"
import script from "./profile2.vue?vue&type=script&lang=js&"
export * from "./profile2.vue?vue&type=script&lang=js&"
import style0 from "./profile2.vue?vue&type=style&index=0&id=c67a3844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67a3844",
  null
  
)

export default component.exports